import { AxiosError } from '@price-for-profit/micro-services';
import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routing';
import { QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';

export function useUserMapping(userId: string) {
  const { userMappingService } = useService();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isFetching } = useQuery(
    [QUERY_KEYS.userMappings, userId],
    () => userMappingService.getUserMapping(userId),
    {
      retry: 2,
      onError: (error: AxiosError) => {
        if (error?.response?.status === 404) {
          enqueueSnackbar('mapping does not exist', { variant: 'error' });
        } else {
          enqueueSnackbar('something went wrong retrieving mapping', { variant: 'error' });
        }

        history.push(ROUTES.userMapping);
      },
    }
  );

  return { userMapping: data, isFetching } as const;
}
